import { combineReducers } from '@reduxjs/toolkit';
import baseAdminDashboardReducer from './adminDashboardSlice';
import codeInjectionReducer from './Pages/CodeInjection/codeInjectionSlice';
import administratorsReducer from './Pages/Administrators/administratorsSlice';
import sectorsManagementReducer from './Pages/SectorsManagement/sectorsManagementSlice';

const adminDashboardReducer = combineReducers({
  base: baseAdminDashboardReducer,
  codeInjection: codeInjectionReducer,
  administrators: administratorsReducer,
  sectorsManagement: sectorsManagementReducer,
});

export default adminDashboardReducer;
